var _defs, _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolPack346({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:0.5px;}.b{fill:#fff;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 3,
    y: 2.96,
    width: 10,
    height: 10
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M7.16,8.86,7.75,9a2.54,2.54,0,0,1-.68,1.35,1.68,1.68,0,0,1-1.18.44,1.88,1.88,0,0,1-1-.29,2.16,2.16,0,0,1-.71-1A4.1,4.1,0,0,1,3.85,8a3.72,3.72,0,0,1,.28-1.5,2.21,2.21,0,0,1,.75-.93,1.88,1.88,0,0,1,1.06-.31A1.62,1.62,0,0,1,7,5.67a2.15,2.15,0,0,1,.64,1.17L7.1,7c-.19-.74-.59-1.11-1.17-1.11a1.32,1.32,0,0,0-.77.22,1.6,1.6,0,0,0-.51.7A3.23,3.23,0,0,0,4.46,8a2.86,2.86,0,0,0,.38,1.65,1.22,1.22,0,0,0,1,.56,1.17,1.17,0,0,0,.82-.34A1.86,1.86,0,0,0,7.16,8.86Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M8.47,10.74V5.37h1.95a2.11,2.11,0,0,1,.91.15,1.14,1.14,0,0,1,.47.5,1.67,1.67,0,0,1,.19.81,1.44,1.44,0,0,1-.32,1,1.46,1.46,0,0,1-.92.48,1.57,1.57,0,0,1,.38.3,3.65,3.65,0,0,1,.45.68l.77,1.46h-.73L11,9.63a6.57,6.57,0,0,0-.52-.89,1,1,0,0,0-.34-.3,1,1,0,0,0-.45-.08H9.05v2.38Zm.58-3h1.26a1.45,1.45,0,0,0,.62-.1.78.78,0,0,0,.34-.31,1,1,0,0,0,.12-.49.84.84,0,0,0-.24-.64.94.94,0,0,0-.7-.23H9.05Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolPack346);
export default __webpack_public_path__ + "static/media/Symbol_pack_346.4c493dbbde2fe612985bac15cf54ed92.svg";
export { ForwardRef as ReactComponent };